import { useQuery } from "@tanstack/react-query";

import { useApi } from "@/shared/api/use-api";

export const useGetSessions = (userId?: number) => {
  const { statsControllerApi } = useApi();

  return useQuery({
    queryKey: [`getStatsSessions`, userId],
    queryFn: ({ signal }) => statsControllerApi.getStatsSessions(userId, { signal }),
    refetchInterval: 10000,
  });
};
